import { SetStateAction, useEffect, useState } from 'react'
import {
  EquipmentTypes,
  TransportLoadCapacities,
  TransportSideTypes,
  TransportTypes,
} from '../../../../types/enums'
import {

  TypesObject,
} from '../../../../types/interfaces'

export const useTransportTypeSelector = (
  setTopData: React.Dispatch<
    SetStateAction<TypesObject > 
  >,
  topData: TypesObject ,
  multiple?: boolean,
) => {
  const [type, setType] = useState<TransportTypes[]>([])
  const [capacity, setCapacity] = useState<TransportLoadCapacities[]>([])
  const [sideType, setSideType] = useState<TransportSideTypes[]>([])
  const [equipment, setEquipment] = useState<EquipmentTypes[]>([])
  // const [on, setOn] = useState<boolean>(false)
  const [capacityValid, setCapacityValid] = useState<boolean>(true)
  const [sideTypeValid, setSideTypeValid] = useState<boolean>(true)

  const toggleType = (value: number) => {
    if (multiple) {
      setType((prev) => {
        if (prev.includes(value)) {
          setTopData((prev) => ({
            ...prev,
            transport_types: [...type.filter((el) => el !== value)],
          }))
          return prev.filter((el) => el !== value)
        }
        setTopData((prev) => ({
          ...prev,
          transport_types: [...type, value],
        }))
        return [...prev, value]
      })
    } else {
      setType([value])
      setTopData((prev) => ({
        ...prev,
        transport_types: [value],
      }))
    }
    setCapacity([])
    setTopData((prev) => ({
      ...prev,
      transport_load_capacities: [],
    }))
    setSideType([])
    setTopData((prev) => ({
      ...prev,
      transport_side_types: [],
    }))
    setEquipment([])
    setTopData((prev) => ({
      ...prev,
      equipment_types: [],
    }))
  }

  const toggleCapacity = (value: number) => {
    if (multiple) {
      setCapacity((prev) => {
        if (prev.includes(value)) {
          setTopData((prev) => ({
            ...prev,
            transport_load_capacities: [...capacity.filter((el) => el !== value)],
          }))
          return prev.filter((el) => el !== value)
        }
        setTopData((prev) => ({
          ...prev,
          transport_load_capacities: [...capacity, value],
        }))
        return [...prev, value]
      })
    } else {
      setCapacity([value])
      setTopData((prev) => ({
        ...prev,
        transport_load_capacities: [value],
      }))
    }
    setSideType([])
    setTopData((prev) => ({
      ...prev,
      transport_side_types: [],
    }))
    setEquipment([])
    setTopData((prev) => ({
      ...prev,
      equipment_types: [],
    }))
  }
  const toggleSideType = (value: number) => {
    if (multiple) {
      setSideType((prev) => {
        if (prev.includes(value)) {
          setTopData((prev) => ({
            ...prev,
            transport_side_types: [...sideType.filter((el) => el !== value)],
          }))
          return prev.filter((el) => el !== value)
        }
        setTopData((prev) => ({
          ...prev,
          transport_side_types: [...sideType, value],
        }))
        return [...prev, value]
      })
    } else {
      setSideType([value])
      setTopData((prev) => ({
        ...prev,
        transport_side_types: [value],
      }))
    }
    setEquipment([])
    setTopData((prev) => ({
      ...prev,
      equipment_types: [],
    }))
  }
  const toggleEquipment = (value: number) => {
    setEquipment((prev) => {
      if (prev.includes(value)) {
        setTopData((prev) => ({
          ...prev,
          equipment_types: [...equipment.filter((el) => el !== value)],
        }))
        return prev.filter((el) => el !== value)
      }
      setTopData((prev) => ({
        ...prev,
        equipment_types: [...equipment, value],
      }))
      return [...prev, value]
    })
  }

  useEffect(() => {
    setCapacityValid(
      type[0] === TransportTypes.CAR ||
        type[0] === TransportTypes.SCOOTER ||
        capacity.length > 0 ||
        !type[0],
    )
  }, [type, capacity])

  useEffect(() => {
    setSideTypeValid(
      type[0] === TransportTypes.CAR ||
        type[0] === TransportTypes.SCOOTER ||
        type[0] === TransportTypes.COMBI_CAR ||
        type[0] === TransportTypes.MINIBUS ||
        sideType.length > 0 ||
        !type[0],
    )
  }, [sideType, type])



  useEffect(() => {
    if (topData.transport_types.length > 0) {
      setType(topData.transport_types)
      if (topData.transport_load_capacities.length > 0)
        setCapacity(topData.transport_load_capacities)
      if (topData.transport_side_types.length > 0) {
        setSideType(topData.transport_side_types)
      }
      if (topData.equipment_types.length > 0) setEquipment(topData.equipment_types)
    }
  }, [topData])

  return {
    type,
    capacity,
    sideType,
    equipment,
    toggleType,
    toggleEquipment,
    toggleCapacity,
    toggleSideType,
    capacityValid,
    sideTypeValid,
    
  }
}
